// @flow
import { useField } from "formik";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_en from "react-date-object/locales/persian_en";
import persian_fa from "react-date-object/locales/persian_fa";
import english from "react-date-object/locales/gregorian_en";
import { Calendar } from "react-multi-date-picker";
import { ajaxWarningAlert } from "utils/alert";
import gregorian_en from "react-date-object/locales/gregorian_en";
import gregorian from "react-date-object/calendars/gregorian";
import { daysOfWeek } from "common/enums/daysOfWeek";

type Props = {
  availableDays: Date[];
  setStep: React.Dispatch<React.SetStateAction<number>>;
  canChangeStep: boolean;
  value: string;
};

export const FormikInjectedCalender = ({
  availableDays,
  setStep,
  canChangeStep,
  value,
}: Props) => {
  const [field, meta, { setValue }] = useField("selectedDate");
  // the format of date is unkown and should code be changed

  const convertGregorianToPersian = (gregorianDate: string) => {
    const date = new DateObject(gregorianDate);
    date.convert(persian, persian_fa);

    return date.format();
  };

  function getRemainingDaysOfWeek() {
    const today = new Date();

    const todayDateObj = new DateObject(today)
      .setCalendar(persian)
      .setFormat("YYYY-MM-DD HH:mm:ss.SSS")
      .setLocale(persian_en);

    const todaysIndexOfWeek = todayDateObj.weekDay.index;
    const remainigDaysOfWeek = daysOfWeek.Friday - todaysIndexOfWeek;
    const remainigDaysOfWeekArr: Date[] = [today];

    for (let index = remainigDaysOfWeek; index >= 0; index--) {
      let newDay = new Date();
      newDay.setDate(today.getDate() + index);
      remainigDaysOfWeekArr.push(newDay);
    }
    return remainigDaysOfWeekArr;
  }

  return (
    <Calendar
      value={value ? convertGregorianToPersian(value) : undefined}
      calendar={persian}
      locale={persian_fa}
      className="noTodayHighlight"
      onFocusedDateChange={(focusedDate, clickedDate) => {
        console.log(focusedDate, clickedDate, value);
        let gregorianDate = focusedDate?.convert(gregorian, english).format();
        setValue(gregorianDate);

        const now = new Date();
        const utcSelectedDate = focusedDate
          ?.convert(gregorian, english)
          .toString();
        console.log("now", now);
        console.log("utcSelectedDate", utcSelectedDate);
        console.log("gregorianDate", gregorianDate);
        // if (canChangeStep) setStep(1);
        // else
        // ajaxWarningAlert(
        //   "لطفا تمامی گزینه ها را انتخاب کنید.",
        //   undefined,
        //   undefined,
        //   {
        //     showCancelButton: false,
        //     showConfirmButton: false,
        //   }
        // );
      }}
      mapDays={({ date, isSameDate }) => {
        // disable remainig days of week
        const activeDay = getRemainingDaysOfWeek().filter((availableDay) => {
          let correctFormatAvailableDay = new DateObject(availableDay);

          correctFormatAvailableDay
            .setCalendar(persian)
            .setFormat("YYYY-MM-DD HH:mm:ss.SSS")
            .setLocale(persian_en);

          let result = isSameDate(date, correctFormatAvailableDay);

          return result;
        });

        if (activeDay[0]) return { disabled: false };
        return { disabled: true };
      }}
    />
  );
};
